module.exports = __webpack_public_path__ + "img/mufid-majnun-cM1aU42FnRg-unsplash.48b54e56.jpg";